var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 30,
  viewBox: "0 0 38 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.667 1.667h26.666c1.834 0 3.334 1.5 3.334 3.333v20c0 1.833-1.5 3.333-3.334 3.333H5.667A3.343 3.343 0 0 1 2.333 25V5c0-1.833 1.5-3.333 3.334-3.333Z",
  stroke: "#fff",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.667 5 19 16.667 2.333 5",
  stroke: "#fff",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgEmail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzOCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjY2NTkgMS42NjY3NUgzMi4zMzMzQzM0LjE2NjYgMS42NjY3NSAzNS42NjY2IDMuMTY2NzUgMzUuNjY2NiA1LjAwMDA4VjI1LjAwMDFDMzUuNjY2NiAyNi44MzM0IDM0LjE2NjYgMjguMzMzNCAzMi4zMzMzIDI4LjMzMzRINS42NjY1OUMzLjgzMzI1IDI4LjMzMzQgMi4zMzMyNSAyNi44MzM0IDIuMzMzMjUgMjUuMDAwMVY1LjAwMDA4QzIuMzMzMjUgMy4xNjY3NSAzLjgzMzI1IDEuNjY2NzUgNS42NjY1OSAxLjY2Njc1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM1LjY2NjYgNUwxOC45OTk5IDE2LjY2NjdMMi4zMzMyNSA1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";